import { getLocalStorage } from '@/utils/localStorage';
import passportMonitor from '@/utils/passportMonitor';
import { CATE_SOURCE, ITEM_DETAIL_SOURCE } from '@/const/dishfood';
import { mapState, mapActions } from 'vuex';
import { LOGIN_SOURCE_MAP, add_login_tag_logs_fun } from '@/const/logs';

/**
 * 目前主要用来处理 EFO 购买等逻辑
 * 也可以用来适配 商家菜品加购逻辑
 */
export default {
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      receivePhone: ({ common }) => common.userInfo.phone,
      receiveCallingCode: ({ common }) => common.userInfo.callingCode,
    }),
    mixinIsLogin() {
      return getLocalStorage('isLogin');
    },
  },
  methods: {
    ...mapActions('store', ['itemDetail']),
    ...mapActions('bill', ['getBillInfoFastBuy']),
    mixinBtnClick(item = {}, payload = {}) {
      this.setClickTrackEvent('sailing_c_x_top_buy_ck', item, payload)
      if (!this.mixinIsLogin) {
        this._passportLoginFun();
        return;
      }
      if (item.cHasWine === 1 || item.maxLevel >= 2) {
        // 有规格菜品&酒类菜品
        this.mixinCardClick(item, payload, true);
        return;
      }
      const nodeList = [item.node];
      nodeList[0].amount = 1;
      this.startBtnClick && this.startBtnClick()
      this.mixinBuyOrAddCart(item, {
        nodeList,
      }, payload)
    },
    async mixinCardClick(item, payload = {}, btn = false) {
      !btn && this.setClickTrackEvent('sailing_c_x_top_item_ck', item, payload)
      if (!this.mixinIsLogin) {
        this._passportLoginFun();
        return;
      }
      let dishFoodInfo = null
      this.startSpecAxios && this.startSpecAxios()
      dishFoodInfo = await this.itemDetail({
        source: ITEM_DETAIL_SOURCE[payload.source] || 0,
        shopId: item.shopId,
        itemId: item.itemId,
      });
      this.endSpecAxios && this.endSpecAxios()
      if (!dishFoodInfo) {
        this.$utils.errorToast(this.$t('请重试'))
        return;
      }
      // 唤起规格页
      let dishInstance = this.$dishFood({
        source: payload.source,
        disabled: false,
        cateItemNum: 0,
        info: dishFoodInfo,
      }).updateCartHook((data) => {
        if (!this.mixinIsLogin) {
          this._passportLoginFun();
          return;
        }
        this.startBtnClick && this.startBtnClick()
        this.mixinBuyOrAddCart(item, {
          nodeList: data
        }, {
          ...payload,
          actInfo: dishFoodInfo?.actInfo,
          dishInstance,
        })
        this.setSailing_c_x_specselection_checkout_ck(item)
      });
      this.hookShowDishLoaded && this.hookShowDishLoaded()
      this.getSailing_c_x_specselection_common_sw(dishFoodInfo, { ...payload});
    },
    mixinBuyOrAddCart(item, params, payload = {}) {
      if (payload.source === CATE_SOURCE.EFO.name) {
        this.mixinGetFastBuy(item, params, payload)
      }
    },
    async mixinGetFastBuy(item, params, payload) {
      payload?.dishInstance?.onShowLoading()
      let res = await this.getBillInfoFastBuy({
        shopId: item.shopId,
        nodeList: JSON.stringify(params.nodeList),
        actInfo: payload.actInfo,
        receivePhone: this.receivePhone,
        receiveCallingCode: this.receiveCallingCode,
      });
      payload?.dishInstance?.onCloseLoading()
      payload?.dishInstance?.onClose()
      res && this.$router.push({
        path: `/bill/${item.shopId}/${res.cartIdStr}`,
      });
    },
    fromIndexGetWrapStatus({btnList = [], titleList = []}, { index, type }) {
      // 获取是否时同一排标志 simple 全部在一行所以设置range 100
      let range = type === 'simple'
        ? 100
        : this.isH5
          ? 2
          : 5
      let wrapIndexBtnList = btnList.map(wrapIndex => {
        return Math.floor(wrapIndex / range)
      })
      let wrapIndexTitleList = titleList.map(wrapIndex => {
        return Math.floor(wrapIndex / range)
      })
      let nowRow = Math.floor(index / range)
      return {
        btn: wrapIndexBtnList.includes(nowRow),
        title: wrapIndexTitleList.includes(nowRow)
      }
    },
    setSailing_c_x_specselection_checkout_ck(item) {
      const params = {
        eventId: 'sailing_c_x_specselection_checkout_ck',
        eventLabel: '规格页-菜品checkout点击',
        attrs: {
          shop_id: item.shopId,
          item_id: item.itemId,
          has_multi_content: item.maxLevel > 1 ? 1 : 0,
          copy_num: 1,
        }
      }
      this.$trackEvent(params);
    },
    setClickTrackEvent(name, item, payload) {
      let map = {
        sailing_c_x_top_buy_ck: '首页专区或特惠菜活动页菜品+点击',
        sailing_c_x_top_item_ck: '菜品组件点击'
      }
      const params = {
        eventId: name,
        eventLabel: map[name] || '',
        attrs: {
          shop_id: item.shopId,
          item_id: item.itemId,
          item_status: 1,
          index: payload.index,
          rec_id: payload.recId,
          from: payload.from,
          max_level: item.maxLevel,
          price: item.price,
          discount_price: item.specialPrice,
          scene: 2, // 场景efo
          meta: {
            page: payload.from === 1 ? 'homepage' : 'showAll',
            page_num: (this.page > 0 ? this.page - 1 : 0) || 0,
            module: 'efo',
            inside_index: payload.index,
          }
        }
      }
      this.$trackEvent(params);
    },
    getSailing_c_x_specselection_common_sw(item, payload) {
      let from = payload.source === CATE_SOURCE.EFO.name
        ? payload.from === 1 ? 7 : 8
        : payload.from
      const data = {
        eventId: 'sailing_c_x_specselection_common_sw',
        eventLabel: '进入规格选择页的页面展示',
        attrs: {
          shop_id: item.shopId,
          shop_status: item.cShopStatus,
          item_id: item.itemId,
          item_status: 1,
          item_position: payload.index,
          sold_status: 1,
          mutiply_level: item.maxLevel,
          has_multi_content: item.maxLevel > 1 ? 1 : 0,
          tab_id: payload.cateId || '',
          tab_position: payload.cateIndex || '',
          from: from, // 1 商家页 3 mini 购物车(购物车改版添加) 4 提单页 7 首页EFO专区 8 EFO活动页
        },
      };
      this.$trackEvent(data);
    },
    /** @desc 处理登录相关逻辑 */
    _passportLoginFun() {
      // 添加【EFO】登录标识
      add_login_tag_logs_fun(LOGIN_SOURCE_MAP.efo);
      passportMonitor.login();
    },
  }
}